import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import store from './store'
import axios from 'axios'
import Blob from './public/Blob.js'
import Cookie from 'js-cookie'
// import '../mock/index.js'
// import '../public/fontsize.js'
import '../public/iconfont/iconfont.css';
import './assets/common.css'
import animated from 'animate.css'
Vue.use(animated)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.HOST = window.baseUrl;
Vue.prototype.ueditorPath = window.ueditorPath;
axios.defaults.withCredentials=true;//解决请求cookie不同无法获取后台session问题
// Vue.prototype.appName = ''

// 网络图片展示
Vue.prototype.getWebPic = function(pic) {
	// console.log(pic);
	if (pic && pic.indexOf('http') > -1 || pic.indexOf('https') > -1 || pic && pic.indexOf('uniapp_temp') > -1 ||
		pic && pic.indexOf('wxfile') > -1) {
		return pic;
	} else if (pic) {
		var _src = (this.HOST + pic).replace(/\\/g, '/');
		// console.log(_src);
		return _src;
	} else {
		return pic;
	}
};
// 时间戳转日期格式
Vue.prototype.ctimeToDate = function(ctime) {
	var date = new Date(ctime * 1000);
	var h = date.getHours() < 10 ? '0' + date.getHours() : String(date.getHours());
	var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	var createTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + h + ':' + m +
		':' +
		s;
	return createTime;
}
// element表格中时间戳转日期
Vue.prototype.getDate = function(row, column) {
		var ctime = row[column.property];
		if (ctime) {
			var date = new Date(ctime * 1000);
			var h = date.getHours() < 10 ? '0' + date.getHours() : String(date.getHours());
			var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
			var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
			var createTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + h + ':' +
				m + ':' +
				s;
			return createTime;
		} else {
			return '';
		}
	},
// 返回上页
Vue.prototype.turnBack = function(){
	this.$router.history.go(-1);
}
// 打开新页面,记录加入路由数组
Vue.prototype.vuePush = function(path,query,title){
	var pathinfo = [];
	pathinfo.title = title.slice(0,4)+'...';
	pathinfo.path = path;
	pathinfo.query = query;
	store.commit('path/addHistoryPath',pathinfo);
	this.$router.push({ path: path, query: query});
}


new Vue({
		render: h => h(App),
		router,
		store,
		axios,
		Cookie
	}).$mount('#app')
	

